import { useContext, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { EthicsComplianceForm } from './EthicsComplianceForm';
import { CreditRiskForm } from './CreditRiskForm';
import { SalesInfoForm } from './SalesInfoForm';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts';
import { RequestStatus, ApplicationRoles } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../../helpers/Common';
import { CreditManagementForm } from './CreditManagementForm';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 20
    }
}));

export const BusinessInfoTab = (props) => {
    const classes = useStyles();
    
    const { 
        userInfo,
        isUserInRole, 
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSubmitting,
    } = useContext(TabsContext);

    const [isCre, setIsCre] = useState(false);
    const [isCreEnabled, setIsCreEnabled] = useState(false);
    const [isEthicsComplianceEnabled, setIsEthicsComplianceEnabled] = useState(false);
    const [isSalesInfoEnabled, setIsSalesInfoEnabled] = useState(false);
    const [isCreditManagementEnabled, setIsCreditManagementEnabled] = useState(false);

    const checkCreditRiskVisibility = () => {
        setIsCre(
            (
                state.request.status === RequestStatus.CreditRiskEvaluation ||
                state.request.status === RequestStatus.CreditRiskReEvaluation ||
                state.request.status === RequestStatus.CreditRiskApproval ||
                state.request.status === RequestStatus.Logistic ||
                state.request.status === RequestStatus.PricingUnit ||
                state.request.status === RequestStatus.AccountReceivableApproval ||
                state.request.status === RequestStatus.WaitingToBeAddedInSap ||
                state.request.status === RequestStatus.Approved ||
                state.request.status === RequestStatus.Blocked ||
                state.request.status === RequestStatus.Closed
            ) &&
            isUserInRoles([
                ApplicationRoles.Administrator,
                ApplicationRoles.CreditRisk, 
                ApplicationRoles.CreditRiskDirector,
                ApplicationRoles.AccountReceivable
            ])
        );
    };

    const checkCreditRiskPermission = () => {
        setIsCreEnabled(
            isSubmitting ||
            state.request.status === RequestStatus.CreditRiskEvaluation ?
            !isUserInRole(ApplicationRoles.CreditRisk) :
            state.request.status === RequestStatus.AccountReceivableApproval ?
            !isUserInRole(ApplicationRoles.AccountReceivable) :
            true
        );
    };

    const checkEthicsCompliancePermission = () => {
        setIsEthicsComplianceEnabled(
            isSubmitting ||
            state.request.status === RequestStatus.CreditRiskEvaluation ?
            !isUserInRole(ApplicationRoles.CreditRisk) :
            true
        );
    }

    const checkSalesInfoPermission = () => {
        setIsSalesInfoEnabled(
            isSubmitting ||
            !(
                (
                    state.request.status === RequestStatus.Draft &&
                    isUserInRole(ApplicationRoles.AOFOpener)
                ) ||
                (
                    state.request.status === RequestStatus.Draft &&
                    state.request.customerRequestId === 0 &&
                    isUserInRole(ApplicationRoles.BossApprover)
                ) ||
                (
                    state.request.status === RequestStatus.ToBeReviewed &&
                    state.request.ownerKey === userInfo.externalKey &&
                    isUserInRole(ApplicationRoles.AOFOpener)
                ) ||
                (
                    state.request.status === RequestStatus.AccountReceivableApproval &&
                    isUserInRole(ApplicationRoles.AccountReceivable)
                )
            )
        );
    };

    const checkCreditManagementPermission = () => {
        setIsCreditManagementEnabled(
            isSubmitting ||
            !(
                state.request.status === RequestStatus.CreditRiskEvaluation &&
                isUserInRole(ApplicationRoles.CreditRisk)
            )
        );
    };

    useEffect(() => {
        checkCreditRiskVisibility();
        checkCreditRiskPermission();
        checkEthicsCompliancePermission();
        checkSalesInfoPermission();
        checkCreditManagementPermission();
    }, [isSubmitting, state.request.status]);

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                {
                    isCre &&
                    <>
                        <Grid item xl={12} xs={12} md={12}>
                            <CreditRiskForm
                                disabled={isCreEnabled}
                            />
                        </Grid>
                        <Grid item xl={12} xs={12} md={12}>
                            <EthicsComplianceForm 
                                disabled={isEthicsComplianceEnabled}
                            />
                        </Grid>
                    </>
                }

                <Grid item xl={12} xs={12} md={12}>
                    <SalesInfoForm
                        disabled={isSalesInfoEnabled}
                    />
                </Grid>

                {
                    state.request.dbType === DbType.S4 && isCre &&
                    <Grid item xl={12} xs={12} md={12}>
                        <CreditManagementForm
                            disabled={isCreditManagementEnabled}
                        />
                    </Grid>
                }
            </Grid>
        </div>
    );
}
